// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * NextWork API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DocStatus } from './docStatus';
import {
    DocStatusFromJSON,
    DocStatusFromJSONTyped,
    DocStatusToJSON,
    DocStatusToJSONTyped,
} from './docStatus';
import type { ProjectStatus } from './projectStatus';
import {
    ProjectStatusFromJSON,
    ProjectStatusFromJSONTyped,
    ProjectStatusToJSON,
    ProjectStatusToJSONTyped,
} from './projectStatus';

/**
 * A project update
 * @export
 * @interface ProjectUpdate
 */
export interface ProjectUpdate {
    /**
     * Whether the project is locked
     * @type {boolean}
     * @memberof ProjectUpdate
     */
    locked?: boolean;
    /**
     * Whether the project has updates
     * @type {boolean}
     * @memberof ProjectUpdate
     */
    hasUpdates?: boolean;
    /**
     * 
     * @type {DocStatus}
     * @memberof ProjectUpdate
     */
    docStatus?: DocStatus;
    /**
     * 
     * @type {ProjectStatus}
     * @memberof ProjectUpdate
     */
    status?: ProjectStatus;
}



/**
 * Check if a given object implements the ProjectUpdate interface.
 */
export function instanceOfProjectUpdate(value: object): value is ProjectUpdate {
    return true;
}

export function ProjectUpdateFromJSON(json: any): ProjectUpdate {
    return ProjectUpdateFromJSONTyped(json, false);
}

export function ProjectUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectUpdate {
    if (json == null) {
        return json;
    }
    return {
        
        'locked': json['locked'] == null ? undefined : json['locked'],
        'hasUpdates': json['hasUpdates'] == null ? undefined : json['hasUpdates'],
        'docStatus': json['docStatus'] == null ? undefined : DocStatusFromJSON(json['docStatus']),
        'status': json['status'] == null ? undefined : ProjectStatusFromJSON(json['status']),
    };
}

export function ProjectUpdateToJSON(json: any): ProjectUpdate {
    return ProjectUpdateToJSONTyped(json, false);
}

export function ProjectUpdateToJSONTyped(value?: ProjectUpdate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'locked': value['locked'],
        'hasUpdates': value['hasUpdates'],
        'docStatus': DocStatusToJSON(value['docStatus']),
        'status': ProjectStatusToJSON(value['status']),
    };
}

